<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23.189"
    height="14.617"
    viewBox="0 0 23.189 14.617"
  >
    <g transform="translate(-1035.507 -584.55)">
      <path
        d="M1045.893,599.166c-1.01,0-1.943-.022-2.727-.074a60.107,60.107,0,0,1-7.2-.826.56.56,0,0,1-.46-.612l.188-1.746a20.276,20.276,0,0,1,.007-4.619c.306-2.186.667-4.572.667-4.572a.578.578,0,0,1,.573-.475l6.706.226a2.422,2.422,0,0,1,.756-1.568,1.752,1.752,0,0,1,1.589-.279c1.074.27,1.56,1.205,2.073,2.193a6.264,6.264,0,0,0,2.488,2.925c.809.452,1.435.821,1.95,1.125a8.232,8.232,0,0,0,2.761,1.259,3.958,3.958,0,0,1,3.23,3.77c.1.86.216,1.986.2,2.2a.558.558,0,0,1-.515.507C1057.83,598.625,1050.9,599.166,1045.893,599.166Zm-9.211-1.915a58.837,58.837,0,0,0,6.551.721,139.872,139.872,0,0,0,14.308-.452c-.027-.3-.075-.789-.161-1.551a2.854,2.854,0,0,0-2.329-2.748,9.252,9.252,0,0,1-3.116-1.394c-.507-.3-1.125-.664-1.927-1.111a7.29,7.29,0,0,1-2.934-3.387c-.49-.943-.794-1.482-1.351-1.621-.407-.108-.557.021-.608.061a1.844,1.844,0,0,0-.377,1.257.57.57,0,0,1-.164.416.616.616,0,0,1-.415.165l-6.753-.229c-.121.809-.37,2.487-.59,4.053a19.087,19.087,0,0,0,0,4.409.573.573,0,0,1,0,.124Z"
        transform="translate(0 0)"
      />
      <path
        d="M1048.84,595.94a80.612,80.612,0,0,1-12.928-1.072l.2-1.1c.114.021,11.481,2.075,21.4.395l.188,1.107A53.857,53.857,0,0,1,1048.84,595.94Z"
        transform="translate(0.049 1.117)"
      />
      <path
        d="M1042.531,593.168a2.631,2.631,0,0,1-2.122-1.8,1.828,1.828,0,0,1,.788-2.227,47.592,47.592,0,0,1,5.806-2.63l.395,1.048a46.751,46.751,0,0,0-5.636,2.549.7.7,0,0,0-.291.9c.2.591.795,1.1,1.072,1.037a42.481,42.481,0,0,0,6.283-2.931l.526.99c-.935.5-5.656,2.977-6.724,3.058A.887.887,0,0,1,1042.531,593.168Z"
        transform="translate(0.58 0.237)"
      />
    </g>
  </svg>
</template>
